module.exports = __webpack_public_path__ + "static/media/14UNEP27.67639b51.jpg";